/**
 * @generated SignedSource<<442401f5c57cf01c001b2c3e460022a1>>
 * @relayHash 54bf8832b9e847d271c3a6eec5ac0493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID caa641396a3c8bf5f7c0c7c24744fa245c689ecc757699d2b7e3f6e9e7f8e919

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateSingleLineTextFieldInput = {
  id: string;
  operation: JiraSingleLineTextFieldOperationInput;
};
export type JiraSingleLineTextFieldOperationInput = {
  operation: JiraSingleValueFieldOperations;
  text?: string | null | undefined;
};
export type singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation$variables = {
  input: JiraUpdateSingleLineTextFieldInput;
};
export type singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation$data = {
  readonly jira: {
    readonly updateSingleLineTextField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateSingleLineTextField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldConfig: {
          readonly isEditable: boolean | null | undefined;
          readonly isRequired: boolean | null | undefined;
        } | null | undefined;
        readonly fieldId: string;
        readonly id: string;
        readonly name: string;
        readonly text: string | null | undefined;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation = {
  rawResponse: singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation$rawResponse;
  response: singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation$data;
  variables: singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleLineTextFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleLineTextField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleLineTextField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleLineTextFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleLineTextField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleLineTextField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "text"
                  },
                  {
                    "concreteType": "JiraFieldConfig",
                    "kind": "LinkedField",
                    "name": "fieldConfig",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isRequired"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "caa641396a3c8bf5f7c0c7c24744fa245c689ecc757699d2b7e3f6e9e7f8e919",
    "metadata": {},
    "name": "singleLineTextHeading_issueFieldSingleLineTextHeading_SingleLineTextHeadingField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5c4362cb1893ce0bef73ee20da807b80";

export default node;
